{
  "scheduleDashboard": {
    "title": "Programación viaje",
    "alerts": {
      "selectFBO": "Seleccione un FBO para ver la programación."
    },
    "viewModes": {
      "timeline": "Cronología",
      "timelineTooltip": "Ver viajes en una línea de tiempo visual/diagrama GANTT",
      "table": "Tabla",
      "tableTooltip": "Ver viajes en una tabla de datos detallada"
    },
    "buttons": {
      "createTrip": "Crear viaje",
      "bulkImport": "Importar lotes"
    },
    "filters": {
      "locationCount": "Filtrado: {{count}} ubicación",
      "statusLabel": "Estado",
      "statusOptions": {
        "all": "Todo estado",
        "scheduled": "Programado",
        "active": "Activo",
        "completed": "Completado",
        "cancelled": "Cancelado",
        "requested": "Solicitado",
        "confirmed": "Confirmado",
        "tenant-based": "Por organización",
        "transient": "Tránsito",
        "hangar": "Hangar"
      },
      "csrStatusOptions": {
        "all": "Todo estado",
        "requested": "Solicitado",
        "confirmed": "Confirmado",
        "completed": "Completado",
        "cancelled": "Cancelado"
      },
      "tailNumberLabel": "Filtrar por matrícula",
      "tailNumberPlaceholder": "N123AB",
      "showPastTrips": "Mostrar viajes pasados"
    },
    "errors": {
      "timelineTitle": "Error de cronología",
      "timelineDescription": "Ocurrió un error al cargar la vista de línea de tiempo. Intenta actualizar la página o cambiar a vista de tabla."
    },
    "emptyState": "No hay viajes programados para el período seleccionado"
  },
  "scheduleList": {
    "columns": {
      "tailNumber": "Matrícula",
      "aircraftModel": "Modelo de aeronave",
      "type": "Tipo",
      "arrival": "Llegada",
      "departure": "Salida",
      "status": "Estado",
      "notes": "Notas",
      "ownerManager": "Propietario/Gerente",
      "assignment": "Asignación",
      "actions": "Acciones"
    },
    "tooltips": {
      "editTrip": "Editar viaje"
    },
    "dateRange": "Mostrando viajes del {{startDate}} al {{endDate}}",
    "tripCount": "Mostrando {{filtered}} de {{total}} viajes",
    "filters": {
      "tailNumberLabel": "Filtrar por matrícula",
      "tailNumberPlaceholder": "p. ej. N123AB",
      "statusLabel": "Estado",
      "statusOptions": {
        "all": "Todo estado",
        "scheduled": "Programado",
        "active": "Activo",
        "completed": "Completado",
        "cancelled": "Cancelado",
        "requested": "Solicitado",
        "confirmed": "Confirmado",
        "tenant-based": "Por organización",
        "transient": "Tránsito",
        "hangar": "Hangar"
      },
      "csrStatusOptions": {
        "all": "Todo estado",
        "requested": "Solicitado",
        "confirmed": "Confirmado",
        "completed": "Completado",
        "cancelled": "Cancelado"
      }
    },
    "noTripsFound": "Sin viajes",
    "bulkActions": {
      "selected": "{{count}} seleccionados",
      "setStatus": "Cambiar estado",
      "assignLocation": "Asignar ubicación",
      "cancel": "Cancelar viajes",
      "delete": "Eliminar",
      "clearSelection": "Limpiar selección",
      "deleteConfirmTitle": "Eliminar viajes seleccionados",
      "deleteConfirmMessage": "¿Está seguro de que desea eliminar permanentemente {{count}} viaje(s)? Esta acción no se puede deshacer.",
      "deleteConfirmButton": "Eliminar",
      "cancelConfirmTitle": "Cancelar viajes seleccionados",
      "cancelConfirmMessage": "¿Está seguro de que desea cancelar {{count}} viaje(s)? Esto cambiará su estado a 'cancelado'.",
      "cancelConfirmButton": "Cancelar viajes",
      "statusSuccess": "Estado actualizado para {{count}} viajes",
      "statusPartial": "Actualizados {{successCount}} viajes ({{failCount}} fallaron)",
      "deleteSuccess": "{{count}} viajes eliminados",
      "cancelSuccess": "{{count}} viajes cancelados",
      "assignSuccess": "{{count}} viajes asignados a {{locationName}}"
    }
  },
  "scheduleTimeline": {
    "tooltip": {
      "location": "Ubicación: {{name}}"
    },
    "deleteConfirmation": {
      "title": "Eliminar viajes seleccionados",
      "message": "¿Seguro que desea eliminar {{count}} viaje seleccionado? Esta acción no se puede deshacer.",
      "deleteButton": "Eliminar",
      "cancelButton": "Cancelar"
    }
  },
  "scheduledHangarView": {
    "updating": "Actualizando...",
    "addObstacleDialog": {
      "title": "Añadir obstáculo móvil",
      "cancelButton": "Cancelar",
      "doneButton": "Listo"
    },
    "errors": {
      "noData": {
        "title": "Sin datos de hangar disponibles",
        "description": "No se pudo cargar la información del hangar para este período. Intenta actualizar la página o seleccionar otro horario.",
        "actionLabel": "Actualizar"
      }
    }
  },
  "scheduledRampView": {
    "errors": {
      "noData": {
        "title": "Sin datos de plataforma",
        "description": "No se pudo cargar la información de plataforma para este período. Intenta actualizar la página o seleccionar otro horario.",
        "actionLabel": "Actualizar"
      }
    },
    "addObstacleDialog": {
      "title": "Añadir obstáculo móvil",
      "buttons": {
        "cancel": "Cancelar",
        "done": "Listo"
      }
    }
  },
  "assignLocationDialog": {
    "title": "Asignar aeronave a ubicación",
    "keepUnassigned": "Mantener sin asignar",
    "current": "Actual",
    "sections": {
      "hangars": "Hangares",
      "ramps": "Rampas"
    },
    "customTimeRange": "Rango personalizado",
    "fields": {
      "startTime": "Hora de inicio",
      "endTime": "Hora de fin"
    },
    "messages": {
      "noLocationsAvailable": "No hay ubicaciones disponibles para el período seleccionado.",
      "unassignedPeriodsWarning": "Se crearán períodos sin asignar antes/después de este rango horario"
    },
    "buttons": {
      "cancel": "Cancelar",
      "assign": "Asignar",
      "assigning": "Asignando..."
    }
  },
  "tripLocationNavigationDialog": {
    "title": "Viaje en otra ubicación",
    "labels": {
      "tripLocation": "UBICACIÓN DEL VIAJE",
      "youreViewing": "ESTÁS VIENDO"
    },
    "messages": {
      "unassignedTrip": "Este viaje aún no ha sido asignado a una ubicación específica.",
      "unassignedExplanation": "Puedes ver el período en que este viaje está programado, pero no tiene asignación de hangar o plataforma.",
      "unassignedPrompt": "Elige si deseas saltar a este período en tu vista actual.",
      "assignedPrompt": "Elige si navegar a la ubicación del viaje o permanecer en la vista actual."
    },
    "buttons": {
      "cancel": "Cancelar",
      "stayIn": "Permanecer en {{locationName}}",
      "goTo": "Ir a {{locationName}}"
    }
  },
  "currentTimeControl": {
    "labels": {
      "currentTime": "Hora actual",
      "viewing": "Viendo: {{startDate}} - {{endDate}}"
    },
    "buttons": {
      "now": "Ya"
    }
  },
  "createTripDialog": {
    "title": {
      "create": "Crear nuevo viaje",
      "newTripFor": "Nuevo viaje para {{tailNumber}}"
    },
    "labels": {
      "ownerManager": "Propietario/Gerente",
      "type": "Tipo",
      "status": "Estado",
      "searchAircraft": "Buscar por marca y modelo",
      "arrivalDateTime": "Fecha y hora de llegada",
      "departureDateTime": "Fecha y hora de salida",
      "notes": "Notas",
      "noDeparture": "Sin salida",
      "required": "*"
    },
    "placeholders": {
      "ownerManager": "p. ej., Juan Pérez",
      "notes": "Requisitos especiales o notas..."
    },
    "tenantTypes": {
      "transient": "Tránsito",
      "base": "Base",
      "yellowCard": "Base + Tarjeta Amarilla"
    },
    "messages": {
      "noScheduledDeparture": "Esta aeronave permanecerá en el FBO indefinidamente sin salida programada.",
      "unassigned": "La aeronave se creará inicialmente como \"sin asignar\" y podrá ubicarse en un hangar o área de plataforma después de su creación.",
      "autoAssigned": "Este viaje se asignará automáticamente al {{locationType}} actual.",
      "autoAssignedSimple": "El viaje se creará para esta aeronave y podrá posicionarse después de la creación."
    },
    "buttons": {
      "cancel": "Cancelar",
      "create": "Crear viaje"
    },
    "tooltips": {
      "conflict": "No se puede crear el viaje: se superpone con un viaje existente",
      "fillRequired": "Por favor, complete todos los campos obligatorios"
    }
  },
  "locationFilter": {
    "label": "Filtrar por ubicación",
    "placeholder": "Todas las sedes",
    "groups": {
      "hangars": "Hangares",
      "ramps": "Rampas"
    }
  },
  "tripEditForm": {
    "labels": {
      "tailNumber": "Matrícula",
      "ownerManager": "Propietario/Gerente",
      "aircraftModel": "Modelo de aeronave",
      "status": "Estado",
      "arrival": "Llegada",
      "departure": "Salida",
      "notes": "Notas",
      "noDeparture": "Sin salida",
      "required": "*"
    },
    "placeholders": {
      "ownerManager": "Ingrese nombre del propietario o gerente",
      "notes": "Añadir notas sobre este viaje..."
    },
    "statuses": {
      "scheduled": "Programado",
      "active": "Activo",
      "completed": "Completado",
      "cancelled": "Cancelado"
    },
    "messages": {
      "baseTenant": "Inquilino base",
      "noScheduledDeparture": "Este avión no tiene salida programada",
      "indefiniteStay": "Esta aeronave permanecerá en el FBO indefinidamente sin salida programada."
    },
    "buttons": {
      "cancel": "Cancelar",
      "save": "Guardar",
      "saving": "Guardando..."
    }
  },
  "simpleBulkUpload": {
    "title": "Carga masiva de viajes",
    "pasteExcel": {
      "title": "Pegar desde Excel",
      "description": "Copia los datos del viaje desde Excel (matrícula, fecha de llegada, fecha de salida) y pégalos a continuación. Para inquilinos base, deja la columna de salida vacía o usa \"sin salida\". Los encabezados son opcionales y se detectarán y omitirán automáticamente.",
      "importButton": "Importar datos",
      "importing": "Importando...",
      "sampleFileButton": "Archivo ejemplo",
      "rowsReady": "{{count}} filas listas para importar"
    },
    "editTrips": {
      "title": "Editar viajes",
      "tableHeaders": {
        "tailNumber": "Matrícula",
        "aircraft": "Aeronave",
        "arrivalDate": "Fecha de llegada",
        "departureDate": "Fecha de salida"
      },
      "addButton": "Añadir",
      "selectAircraft": "Seleccionar aeronave",
      "placeholders": {
        "tailNumber": "N123AB"
      },
      "validationErrors": {
        "arrivalBeforeDeparture": "La llegada debe ser antes de la salida",
        "departureAfterArrival": "La salida debe ser posterior a la llegada"
      }
    },
    "messages": {
      "autoAssign": "Los viajes se asignarán automáticamente a {{locationName}}",
      "validTripsCount": "{{count}} viajes válidos"
    },
    "buttons": {
      "cancel": "Cancelar",
      "save": "Guardar {{count}} viajes"
    },
    "progress": {
      "uploadingTitle": "Subiendo viajes",
      "uploadingMessage": "Creando viajes y asignando a ubicación. Por favor espere...",
      "itemName": "viaje"
    },
    "sampleFile": {
      "header": "Matrícula\tFecha de llegada\tFecha de salida"
    },
    "errors": {
      "noActiveFBO": "No hay FBO activo seleccionado",
      "noValidTrips": "No hay viajes válidos a guardar",
      "missingAircraftData": "No se pueden cargar vuelos sin datos de aeronave. Por favor, seleccione la aeronave para: {{tailNumbers}}",
      "failedTenantSearch": "Error al buscar organización: {{message}}",
      "missingAircraftId": "Error interno: el viaje no tiene aircraft_id para {{tailNumber}} - debería detectarse en la validación",
      "failedTenantCreate": "Error al crear el inquilino: {{message}}",
      "assignmentFailed": "{{tailNumber}}: Viaje creado pero la asignación falló - {{message}}",
      "unknownError": "Error desconocido",
      "tripCreationFailed": "{{tailNumber}}: {{message}}",
      "saveFailed": "No se pudieron guardar los viajes. Intenta de nuevo."
    },
    "success": {
      "allSucceeded": "✓ {{count}} viaje{{locationMessage}} añadido correctamente",
      "partialSuccess": "✓ Se añadieron {{successCount}} de {{totalCount}} viajes{{locationMessage}}.\n\n✗ Fallaron {{failedCount}}:\n{{errors}}",
      "allFailed": "✗ Error al añadir viajes:\n{{errors}}"
    },
    "successState": {
      "dialogTitle": "Carga completa",
      "title": "Viajes creados correctamente",
      "message": "{{count}} viaje(s) añadidos al calendario.",
      "assignedTo": "Asignados a {{locationName}}.",
      "viewTrips": "Ver viajes",
      "done": "Listo"
    }
  },
  "tripDetailsModal": {
    "title": "Detalles del viaje",
    "buttons": {
      "newTrip": "Nuevo viaje",
      "view": "Ver",
      "edit": "Editar",
      "close": "Cerrar",
      "cancelTrip": "Cancelar viaje",
      "deleteTrip": "Eliminar viaje",
      "assignToLocation": "Asignar a ubicación",
      "save": "Guardar",
      "saving": "Guardando...",
      "deleting": "Eliminando...",
      "cancelling": "Cancelando...",
      "cancel": "Cancelar",
      "keepTrip": "Mantener"
    },
    "labels": {
      "tailNumber": "Matrícula",
      "ownerManager": "Propietario/Gerente",
      "aircraft": "Aeronave",
      "arrival": "Llegada",
      "departure": "Salida",
      "duration": "Duración",
      "notes": "Notas",
      "locationHistory": "Historial de ubicación",
      "tripNavigation": "Navegación de vuelos"
    },
    "placeholders": {
      "ownerManager": "Ingrese nombre del propietario o gerente",
      "notes": "Añadir notas...",
      "unknown": "Desconocido",
      "noNotes": "Sin notas",
      "unassigned": "Sin asignar"
    },
    "chips": {
      "transient": "Tránsito"
    },
    "duration": {
      "indefinite": "Indefinido",
      "days": "{{days}}d {{hours}}h {{minutes}}m",
      "hours": "{{hours}}h {{minutes}}m",
      "minutes": "{{minutes}}m"
    },
    "tableHeaders": {
      "location": "Ubicación",
      "arrival": "Llegada",
      "departure": "Salida",
      "duration": "Duración"
    },
    "navigation": {
      "previous": "Anterior: {{dates}}",
      "next": "Siguiente: {{dates}}",
      "noOtherTrips": "Sin otros viajes"
    },
    "confirmations": {
      "deleteTitle": "Eliminar viaje",
      "deleteMessage": "¿Está seguro de que desea eliminar permanentemente este viaje para {{tailNumber}}? Esta acción no se puede deshacer y eliminará todo el historial de ubicaciones.",
      "cancelTitle": "Cancelar viaje",
      "cancelMessage": "¿Está seguro de que desea cancelar este viaje para {{tailNumber}}? Esto cambiará el estado del viaje a \"cancelado\" y no podrá deshacerse fácilmente."
    },
    "tooltips": {
      "unassigned": "La aeronave no está asignada a un hangar específico o ubicación en plataforma durante este período. Puede estar en estacionamiento de tránsito o esperando asignación de ubicación."
    }
  },
  "aircraftTripsModal": {
    "title": "Viajes de {{tailNumber}}",
    "emptyState": {
      "title": "Sin viajes",
      "description": "Este avión aún no tiene viajes programados."
    },
    "tripCount": "Mostrando {{count}} viaje",
    "clickToView": "Haz clic en un viaje para ver detalles",
    "viewingTrip": "Viendo viaje para {{tailNumber}}",
    "duration": {
      "daysAndHours": "{{days}} día, {{hours}} h",
      "hoursAndMinutes": "{{hours}} h, {{minutes}} min",
      "minutes": "{{minutes}} min"
    },
    "tripDetails": {
      "title": "Detalles del viaje",
      "editTooltip": "Editar viaje",
      "unknown": "Desconoc.",
      "labels": {
        "aircraft": "Aeronave",
        "arrival": "Llegada",
        "departure": "Salida",
        "duration": "Duración",
        "notes": "Notas"
      }
    }
  },
  "scheduleListPage": {
    "alerts": {
      "selectFBO": "Seleccionar FBO"
    },
    "buttons": {
      "createFirstTrip": "Crear primer viaje",
      "createTrip": "Crear viaje",
      "timelineView": "Vista cronológica"
    },
    "emptyState": {
      "description": "Descripción",
      "title": "Estado vacío"
    },
    "title": "Listado de programación"
  }
}
